import "./ProjectsScreen.css";

function ExternalIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M14 3h7v7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M21 14v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

export default function ProjectsScreen({ items }) {
  return (
    <section className="section" id="projects">
      <div className="sectionHeader">
        <div className="sectionNum">04.</div>
        <div className="sectionTitle">Featured Projects</div>
      </div>

      <div className="projectList">
        {items.map((p) => (
          <div key={p.title} className="project">
            <div>
              <h3 className="projectTitle">{p.title}</h3>
              <p className="projectDesc">{p.desc}</p>

              <div className="pills">
                {p.tags.map((t) => <span key={t} className="pill">{t}</span>)}
              </div>
            </div>

            <div className="projectRight">
              {p.links.map((l) => (
                <a key={l.label} className="iconBtn" href={l.href} target="_blank" rel="noreferrer">
                  <ExternalIcon /> {l.label}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
